import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';



const IntroductionMemorialPC = () => {
  const navigate = useNavigate();

  // State for mobile banner carousel
  const [currentSlide, setCurrentSlide] = useState(0);

  // responsive flag: consider mobile when width <= 768
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // update isMobile on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Memorial content data for the carousel
  const memorialContent = [
    {
      image: "/indtoudction pc_1/group-117@3x.png",
      title: "영원한 안식처의 공간",
      subtitle: "가족분들의 마음의 안식처가 되는 추모의 공간입니다."
    },
    {
      image: "/indtoudction pc_1/group-118@3x.png",
      title: "추억이 살아있는 공간",
      subtitle: "함께했던 추억을 되새길 수 있는 시간이 되시기를 바랍니다."
    },
    {
      image: "/indtoudction pc_1/group-119@3x.png",
      title: "문화와 추모가 어우러진 공간",
      subtitle: "관광도시 강화도에서 추모의 시간과 가족의 화목함이 함께 어우러지시기를 바랍니다."
    }
  ];

  // timeline data (keep same content & image paths you provided)
  const timelineData = [
    {
      year: "2001",
      date: "12.28",
      event: "납골당 설치 신고 필",
      img: "/indtoudction pc_1/group-123.png",
    },
    {
      year: "2001",
      date: "11.14",
      event: "납골 시설물 분양 가격 신고 필",
      img: "/indtoudction pc_1/group-122.png",
    },
    {
      year: "2001",
      date: "06.28",
      event: "납골당 형질변경 준공 필",
      img: "/indtoudction pc_1/group-121.png",
    },
    {
      year: "1998설립",
      date: "12.28",
      event: "납골당 설치 허가",
      img: "/indtoudction pc_1/group-126.png",
    },
  ];

  // mobile => original order, desktop => reversed order
  const itemsToRender = isMobile ? timelineData : [...timelineData].reverse();
  // Navigation functions
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % memorialContent.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + memorialContent.length) % memorialContent.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />

      {/* Main Content */}
      <main className="main-content introduction-memorial-page">
        <IntroSubHeading heading="추모원 소개" />

        {/* Intro Section */}
        <section className="introduction-memorial-section">

          <div className="image45-section">
            <img src="/indtoudction pc_1/sub-img@3x.png" alt="추모원 소개 이미지" className="image45" />
            <div className="mobile-image-container">
              <img src="/images/TakeLook/추모원소개_img01.jpg" alt="CEO Greeting" className="ceo-greeting-black" />
              <div className="mobile-text-overlay">
                <div className="korean-quote">
                  <span className="quote-line-1"><span className="text-style-1">강화파라다이스 추모원</span>은</span>
                  <span className="quote-line-2"><span className="text-style-1">함께하는 시간이</span></span>
                  <span className="quote-line-3"><span className="text-style-1">행복한 공간입</span>니다.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="intro-features-grid">
            <div className="intro-feature-card">
              <div className="intro-feature-image-wrapper">
                <img src="/images49/7_309.svg" alt="" className="intro-feature-bg" />
                <img src="/images49/1a9bbc00bf04cb7fc3e5d0b296e14e256bae7db4.png" alt="휴식" className="intro-feature-img" />
              </div>
              <h3>Rest</h3>
              <p>파라다이스추모원은 공원에 오신 듯 성묘뿐만이 아니라 복잡한 도심에서 벗어나 쉬어가실 수 있는 휴식의 공간입니다.</p>
            </div>
            <div className="intro-feature-card">
              <div className="intro-feature-image-wrapper">
                <img src="/images49/7_320.svg" alt="" className="intro-feature-bg" />
                <img src="/images49/f062434e4432655199cf1bbd28e6503966898d94.png" alt="편안함" className="intro-feature-img" />
              </div>
              <h3>Comfort</h3>
              <p>고인들이 편히 영면하실 수 있도록 최선을 다해 관리하고 있습니다. 세심한 묘터 관리와 편안하고 아늑한 성묘가 될 수 있도록 임직원 모두가 예와 정성을 다해 노력하고 있습니다.</p>
            </div>
            <div className="intro-feature-card">
              <div className="intro-feature-image-wrapper">
                <img src="/images49/7_329.svg" alt="" className="intro-feature-bg" />
                <img src="/images49/1d29051ec48436bc4efa644487ea685f9d9b0e38.png" alt="위치" className="intro-feature-img" />
              </div>
              <h3>Locations</h3>
              <p>그리울 때 보고플 때 문득 생각날 때 언제든지 찾아오실 수 있는 수도권 근교에 위치한 추모의 공간입니다.</p>
            </div>
            <div className="intro-feature-card">
              <div className="intro-feature-image-wrapper">
                <img src="/images49/e4308c4906d6914b098f63ea77e6ba22a180934e.png" alt="함께" className="intro-feature-img" />
              </div>
              <h3>Together</h3>
              <p>과거와 현재 그리고 미래가 함께 공존하는 추모공원입니다.</p>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="story-section">
          <div className="story-section-wrapper">
            <article className="story-item">
              <div className="story-image">
                <img src="/images49/48e9541d690d221b957d8ca440d0c70b05387f4c.png" alt="천혜의 명당" />
              </div>
              <div className="story-text">
                <h3><span className="highlight-green">천혜의 명당</span>인</h3>
                <p>강화도 고려산에 위치하여 모셔진 모든 분들의 영면을 기원하고 방문하시는 모든 추모객분들이 고인과의 애틋했던 추억들과 추모의 정을 영원히 이어 나가실 수 있기를 바라고 있습니다.</p>
              </div>
            </article>
            <article className="story-item">
              <div className="story-image">
                <img src="/images49/2539aa566b7857968c96c30a442ed9abf386a17a.png" alt="복합봉안시설" />
              </div>
              <div className="story-text">
                <h3><span className="highlight-green">국내 최초의 복합봉안시설 추모공원</span>으로</h3>
                <p>2003년부터 현재까지 약 30,000여 위(位)의 분들을 모시고 있습니다. 강화파라다이스 추모원은 장묘 문화의 새로운 가치를 창조하고 더욱 나은 서비스와 행복한 공간을 만들어 나가고자 노력하고 있습니다.추모객 분들과 끊임없이 소통하고 특별한 날에만 찾는 곳이 아닌 진정으로 추모의 정을 느끼실 수 있는 곳이 되고자 임직원이 일심하여 부단히 노력하고 있습니다.</p>
              </div>
            </article>
            <article className="story-item">
              <div className="story-image">
                <img src="/images49/f7ea096c5d0341cd4987661550cb3f1597a0aafe.png" alt="변치 않는 추억" className="img-1" />
                {/* <img src="/images49/3e6c1fce2a619b51c3f27ee006a9272530e697a5.png" alt="변치 않는 추억" className="img-2" /> */}
              </div>
              <div className="story-text">
                <h3><span className="highlight-green">추억들이 변치 않고 간직</span>되는 장소</h3>
                <p>꽃은 시들고 세상은 변해가고 아이는 어른으로 어른은 노인으로 되어가도 추억은 결코 변하지 않습니다 누군가에게는 다짐의 장소가 누군가에게는 추억의 장소가 되는 추모원입니다.</p>
              </div>
            </article>
          </div>
        </section>

        {/* Quote Section */}
        <section className="quote-section">
          <div className="styled-quote">
            <div className="quote-line left"></div>
            <div className="quote-content">
              <div className="quote-text">
                <p>정이 있어 행복한 공간, <br className="mobile-line-break" /> 고인과의 추억을 간직할 수 있는 공간</p>
                <p><strong>시간이 지날수록 더욱 깊어지는 <br className="mobile-line-break" /> 정을 만들어 나가는 추모공원</strong></p>
              </div>
            </div>
            <div className="quote-line right"></div>
          </div>
        </section>

        {/* Three Circles Section */}
        <section className="memorial-circles-section">
          <div className="memorial-circles-wrapper">
            <div className="memorial-circles-container">
              <div className="memorial-circle-item">
                <div className="memorial-circle-image">
                  <img src="/indtoudction pc_1/group-117@3x.png" alt="영원한 안식처의 공간" />
                </div>
                <div className="memorial-circle-text">
                  <h3>영원한 안식처의 공간</h3>
                  <p>가족분들의 마음의 안식처가 되는 추모의 공간입니다.</p>
                </div>
              </div>

              <div className="memorial-circle-connector">
                <div className="memorial-plus-icon">
                  <img src="/indtoudction pc_1/group-120@3x.png" alt="plus" />
                </div>
              </div>

              <div className="memorial-circle-item">
                <div className="memorial-circle-image">
                  <img src="/indtoudction pc_1/group-118@3x.png" alt="추억이 살아있는 공간" />
                </div>
                <div className="memorial-circle-text">
                  <h3>추억이 살아있는 공간</h3>
                  <p>함께했던 추억을 되새길 수 있는 시간이 되시기를 바랍니다.</p>
                </div>
              </div>

              <div className="memorial-circle-connector">
                <div className="memorial-plus-icon">
                  <img src="/indtoudction pc_1/group-120@3x.png" alt="plus" />
                </div>
              </div>

              <div className="memorial-circle-item">
                <div className="memorial-circle-image">
                  <img src="/indtoudction pc_1/group-119@3x.png" alt="문화와 추모가 어우러진 공간" />
                </div>
                <div className="memorial-circle-text">
                  <h3>문화와 추모가 어우러진 공간</h3>
                  <p>관광도시 강화도에서 추모의 시간과 가족의 화목함이 함께 어우러지시기를 바랍니다.</p>
                </div>
              </div>
            </div>

            {/* Mobile Banner */}
            <div className="mobile-banner">
              <div className="banner-image">
                <img src={memorialContent[currentSlide].image} alt="추모 공간" />
              </div>
              <div className="banner-content">
                <div className="nav-arrow" onClick={prevSlide}><img src="/images/Main/arrow-right-white.png" alt="Next" /></div>
                <div className="banner-content-wrapper">
                  <h3 className="banner-title">{memorialContent[currentSlide].title}</h3>
                  <p className="banner-subtitle">{memorialContent[currentSlide].subtitle}</p>
                </div>
                <div className="nav-arrow" onClick={nextSlide}><img src="/images/Main/arrow-left-white.png" alt="Next" /></div>
              </div>
              <div className="banner-navigation">
                <div className="pagination-dots">
                  {memorialContent.map((_, index) => (
                    <div
                      key={index}
                      className={`dot ${currentSlide === index ? 'active' : ''}`}
                      onClick={() => goToSlide(index)}
                    ></div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        </section>

        {/* Status Section */}
        <section className="status-section">
          <div className="status-section-wrapper">
            <h2 className="intro-status-section-title">추모원 현황</h2>
            <div className="status-grid">
              <div className="status-item">
                <div className="icon-wrapper">
                  <img src="/images49/7_253.svg" alt="" className="icon-bg" />
                  <img src="/images49/5d5e007fa3f9d14da5cf887349e84e0aba6fc324.png" alt="소재지 아이콘" className="icon-img" />
                </div>
                <h3>소재지</h3>
                <p>인천시 강화군 송해면<br />강화대로 879-16</p>
              </div>
              <div className="status-item">
                <div className="icon-wrapper">
                  <img src="/images49/7_253.svg" alt="" className="icon-bg" />
                  <img src="/images49/716f4474ef4adf4afed2a659a3cd9fe8f28962d9.png" alt="기업이념 아이콘" className="icon-img" />
                </div>
                <h3>기업이념</h3>
                <p>신뢰, 신의</p>
              </div>
              <div className="status-item">
                <div className="icon-wrapper">
                  <img src="/images49/7_253.svg" alt="" className="icon-bg" />
                  <img src="/indtoudction pc_1/heart@2x.png" alt="안치기수 아이콘" className="icon-img" />
                </div>
                <h3>안치기수</h3>
                <p>약 3만여 위</p>
              </div>
              <div className="status-item">
                <div className="icon-wrapper">
                  <img src="/images49/7_253.svg" alt="" className="icon-bg" />
                  <img src="/indtoudction pc_1/wall-clock@2x.png" alt="운영시간 아이콘" className="icon-img" />
                </div>
                <h3>운영시간</h3>
                <p>하절기 08:30 ~ 17:30<br />동절기 08:30 ~ 17:00</p>
              </div>
            </div>
          </div>
        </section>

        {/* History Section */}
        <section className="history-section">
          <div className="history-section-wrapper">
            <h2 className="intro-status-section-title">추모원 연혁</h2>
            <div className="timeline">
              <div className="timeline-line"></div>

              {itemsToRender.map((item, idx) => (
                <div className="timeline-item" key={idx}>
                  <div className="timeline-content">
                    <div className="timeline-image-wrapper">
                      <img src={item.img} alt={item.year} className="timeline-img" />
                    </div>
                    <div className="timeline-milestone-content">
                      <div className="year">{item.year}</div>
                      <div className="timeline-milestone">
                        <div className="milestone-dot">
                          <img src="/indtoudction pc_1/group-100@2x.png" alt="arrow" />
                        </div>
                        <div className="date">{item.date}</div>
                        <div className="event">{item.event}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </section>


      </main>
    </div>
  );
};

export default IntroductionMemorialPC; 